module.exports = __webpack_public_path__ + "static/logo.inline-1335f1d1e09597b9680ae9c10e5a1577.svg";